

export const validate=(email,password)=>{
    const isemailValid=/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)
    const isPasswordValid=/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password)

    if(!isemailValid) return "The emails format is invalid"
    if(!isPasswordValid) return "The Password format is invalid"
    if(isemailValid && isPasswordValid) return null
}